<i class="sp-mr-8" *ngIf="nzIcon" [uiType]="nzIcon" ui-icon></i>
<ng-container *nzStringTemplateOutlet="nzTitle">
  <span class="title-item">{{ nzTitle }}</span>
</ng-container>
<ng-content></ng-content>
<span class="ant-dropdown-menu-submenu-expand-icon" *ngIf="isMenuInsideDropDown; else notDropdownTpl" [ngSwitch]="dir">
  <i class="ant-dropdown-menu-submenu-arrow-icon" *ngSwitchCase="'rtl'" ui-icon uiType="chevron-left-big"></i>
  <i class="ant-dropdown-menu-submenu-arrow-icon" *ngSwitchDefault ui-icon uiType="chevron-right-big"></i>
</span>
<ng-template #notDropdownTpl>
  <i class="ant-menu-submenu-arrow"></i>
</ng-template>
